(() => {
  if (customElements.get('cf-product-recommendations')) return;

  customElements.whenDefined('product-recommendations').then(() => {
    if (customElements.get('cf-product-recommendations')) return;

    const ProductRecommendations = customElements.get('product-recommendations');

    customElements.define('cf-product-recommendations', class extends ProductRecommendations {
      connectedCallback() {
        if (this.cfRequested) return;

        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
          this.cfLoad();
          return;
        }

        this.cfObserver?.disconnect();
        this.cfObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.cfLoad();
        }, { rootMargin: '600px 0px' });
        this.cfObserver.observe(this);
      }

      cfLoad() {
        if (this.cfRequested) return;
        this.cfRequested = true;
        this.cfObserver?.disconnect();
        super.connectedCallback();
      }

      disconnectedCallback() {
        this.cfObserver?.disconnect();
      }
    });
  });
})();
